import {
  TSizeFont,
  TSizeRadius,
  TSizeSpacing,
} from '@coverflex-tech/hypernova-design-tokens';

type TSizeToken = TSizeSpacing | TSizeRadius | TSizeFont;
type TTransformableRemToken<T extends TSizeToken> = Partial<Record<T, number>>;
type TTransformedRemTokenRecord<T extends TSizeToken> = Record<T, string>;

export const convertTokenValueToRems = <T extends TSizeToken>(
  token: TTransformableRemToken<T>
): TTransformedRemTokenRecord<T> => {
  const result = {} as TTransformedRemTokenRecord<T>;

  Object.keys(token).forEach((key) => {
    const sizeKey = key as T;
    const value = token[sizeKey];
    if (typeof value === 'number') {
      result[sizeKey] = `${(value / 10).toFixed(1)}rem`;
    }
  });

  return result;
};
